function a(s, e, r) {
  const i = s.getAttribute("class") || "", t = new Set(i.split(/\s+/).filter(Boolean));
  r ? t.add(e) : t.delete(e), s.setAttribute("class", Array.from(t).join(" "));
}
export {
  a as u
};
